@if(roleService.userHasRole('expired', true)) {
<div
  class="justify-content-center flex-wrap rounded text-white border-success p-3 mb-3 bg-light-transparent-1 d-flex align-items-center {{
    baseCssClass
  }}"
>
  <div class="flex-fill d-flex align-items-center">
    <i class="icon-20 me-3 icon icon-circle-exclamation"></i>
    <div class="big fw-bold" translate>Membership expired</div>
  </div>
  <button class="btn d-flex align-items-center btn-success btn-sm rounded" (click)="renewMembership()">
    <i class="icon icon-sync me-1"></i>
    <span translate>Renew</span>
  </button>
</div>
}@else {
<div (click)="membershipNavigation()" class="justify-content-center align-items-center {{ cssClass() }}">
  <i class="icon icon-16 icon-crown me-2"></i>
  <span class="border-bottom border-success">{{ membershipPlanLevel() }} Membership</span>
</div>
}
